









import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import config from "@/config";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "CreatorsSliderItem",
  components: { BaseAvatar },
  props: {
    creator: { type: Object as () => UserPublicData, required: true },
  },
  setup(props) {
    const profileUrl = computed(() => getProfileUrl(props.creator));
    const showStoryInfo = computed(() => config.featureStories);
    return { profileUrl, showStoryInfo, resolveUserName };
  },
});
